import * as React from "react";

const styles = require("../styles.module.scss");

interface Props {
  fields: Object;
}

const Fields: React.FC<Props> = ({ fields }) => (
  <table className={styles.fields}>
    <tbody>
      {Object.keys(fields).map(k => (
        <tr key={k}>
          <td>{k}</td>
          <td>{fields[k]}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default Fields;
